import { PathModule } from "app/common/LocalConst";
import { EgretLoadable } from "egret";

const PublicRoute = {
  path: PathModule.PUBLIC,
  exact: true,
  children: [
    {
      path: "appointment-tracking",
      exact: true,
      component: EgretLoadable({
        loader: () =>
          import(
            "app/PatientManagement/AppointmentTracking/AppointmentTrackingIndex"
          ),
      }),
    },
  ],
};

export default PublicRoute;
